import { createMeasureContainer } from './measureContainer';
import { handleTextStructure } from '../TextStructureHandler/paging';
import { handleContentStructure } from '../ContentStructureHandler/paging';

/**
 * 純函數：將 HTML 字串按行數分頁，返回新的 HTML 字串和總頁數
 * @param {string} htmlString - 原始 HTML 字串
 * @param {number} lineHeight - 行高（像素）
 * @param {number} pageSize - 每頁最大行數
 * @param {HTMLElement} referenceContainer - 用於獲取樣式的參考容器
 * @returns {{htmlString: string, totalPages: number}} 分頁後的 HTML 字串和總頁數
 */
export const splitIntoPagesString = (htmlString, lineHeight, pageSize, referenceContainer, extendedResourceStyle) => {
  // 使用 DOMParser 解析 HTML 字串，不影響實際 DOM
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  // 從 parsed doc 提取外層 wrapper 的 className（如 "simple MATH SECONDARY"）
  // 確保 measureContainer 能套用依賴祖先選擇器的 CSS 規則
  const outerWrapper = doc.body.querySelector('.simple, .fill, .topic, .plain_text, .imageSet');
  const outerWrapperClassName = outerWrapper ? outerWrapper.className : '';

  const measureContainer = createMeasureContainer(referenceContainer, outerWrapperClassName);

  // 掛到 #exContainer 確保繼承 ExtendedContentContainer 的 CSS 上下文
  const exContainer = document.getElementById('exContainer');
  if (exContainer) {
    exContainer.appendChild(measureContainer);
  } else {
    document.body.appendChild(measureContainer);
  }

  try {
    // 判斷 DOM 結構類型：檢查是否存在 .text 或 .content 元素
    const textElements = doc.querySelectorAll('.text');
    const contentElements = doc.querySelectorAll('div.content');
    
    // 判斷使用哪種 DOM 結構
    let domStructureType = null;
    if (textElements.length > 0) {
      domStructureType = 'text';
    } else if (contentElements.length > 0) {
      domStructureType = 'content';
    } else {
      // 如果都沒有，預設使用 text 結構
      domStructureType = 'text';
    }
    
    // 根據 DOM 結構類型進行不同的處理
    if (domStructureType === 'content') {
      return handleContentStructure(doc, contentElements, lineHeight, pageSize, measureContainer);
    } else {
      return handleTextStructure(doc, textElements, lineHeight, pageSize, measureContainer, extendedResourceStyle);
    }
  } finally {
    if (measureContainer.parentNode) {
      measureContainer.parentNode.removeChild(measureContainer);
    }
  }
};

